import { queryOperationLog, queryTaskNo } from '@/modules/transport/otp/api/performanceDispatchMgmt';
import { nodeOptions, orderOptions, logOptions } from './config';
import PerformancePreviewFile from './previewFile.vue';
import { filterTreeData, findSingleMatch, formatLogData, formatDictDataToNodeId, copyToClip } from './utils';

export default {
    name: 'operationNodeLog',
    components: { PerformancePreviewFile },
    props: {
        componentsData: {
            type: Object,
            default () {
                return {};
            }
        },
        dictData: {
            type: Object,
            default () {
                return {};
            }
        },
        taskNo: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            orderOptions: JSON.parse(JSON.stringify(orderOptions)),
            nodeOptions: JSON.parse(JSON.stringify(nodeOptions)),
            logOptions: JSON.parse(JSON.stringify(logOptions)),
            firstLineData: null,
            loading: false,
            attachmentShow: false,
            disableOrderInput: false,
            dispatchNo: '',
            orderNo: '',
            clickOrderNo: '',
            clickNode: '',
            preOrderNo: '',
            selectedTaskNo: {},
            orderNoList: [],
            printLogList: [],
            tableAttachmentList: []
        };
    },
    async mounted () {
        this.dispatchNo = this.componentsData.dispatchNo;
        this.firstLineData = { id: 0, orderNo: this.dispatchNo };
        if (this.taskNo) {
            this.orderNo = this.taskNo;
            this.disableOrderInput = true;
        }
        this.getDicData();
        await this.getOrder();
    },
    methods: {
        filterOrderTable () {
            const $grid = this.$refs.orderGridRef;
            if (!$grid) return;
            
            const searchText = this.orderNo.toLowerCase();
            // CP单（id为0）不参与搜索，所以过滤掉，对其余数据进行搜索完成后再将CP单插入到首位
            const data = this.orderOptions.data.filter(v => v.id);
            const filteredData = filterTreeData(data, searchText);

            if (!filteredData.length) return this.$message.warning(`单号${this.orderNo}不属于此发车单，请重新输入`);

            // 如果搜索框内容未发生变化，则不进行搜索
            if (this.preOrderNo && this.preOrderNo === this.orderNo) return;
            this.preOrderNo = this.orderNo;

            $grid.clearCurrentRow();

            if (!searchText) {
                $grid.loadData(this.orderOptions.data);
                // 如果搜索框为空，则将CP单设置为选中
                this.setCurrentRow('orderGridRef', this.firstLineData);
                this.handleSearch();
                return;
            }

            filteredData.unshift(this.firstLineData);

            $grid.loadData(filteredData);

            // 如果配到到数据，则将第一个匹配项选中，但是由于存在首行展示的CP单，所以判断length为大于等于2 而不是1
            if (filteredData.length >= 2) {
                const { singleMatch, parentNode } = findSingleMatch(filteredData.filter(v => v.id), searchText);
                this.selectedTaskNo = singleMatch;
                if (singleMatch) {
                    this.setCurrentRow('orderGridRef', singleMatch);
                    if (parentNode) {
                        // 如果存在父节点，则展开父节点
                        $grid.setTreeExpand(parentNode, true);
                    }
                }
                this.handleSearch();
            }
        },
        handleSearch () {
            this.$nextTick(() => {
                const data = this.getSelectedData();
                this.getLog(data);
            });
        },
        clickOrderCell ({ row }) {
            if (this.taskNo) {
                return this.setCurrentRow('orderGridRef', this.selectedTaskNo); // 运单查看时，禁止切换
            };
            if (this.clickOrderNo && this.clickOrderNo === row.orderNo) return; // 防止重复点击
            this.clickOrderNo = row.orderNo;
            
            if (row.childList) { // 点击客户订单号不触发查询
                this.logOptions.data = [];
                return;
            };
            this.setCurrentRow('nodeGridRef', this.nodeOptions.data[0]); // 重置节点选中
            this.handleSearch();
        },
        clickNodeCell ({ row }) {
            if (this.clickNode && this.clickNode === row.node) return; // 防止重复点击
            this.clickNode = row.node;
            this.handleSearch();
        },
        handleImgClick (row) {
            this.tableAttachmentList = row.picList.map(v => {
                return {
                    updateTime: v.picUploadTime,
                    updateUserName: v.picUploadUserName,
                    fileType: v.objTypeName,
                    path: v.picUrl
                };
            });
            this.attachmentShow = true;
        },
        toggleTreeExpand ({ expanded, row }) {
            if (expanded && this.clickOrderNo !== row.childList[0].orderNo) {
                this.$refs.orderGridRef.clearSelected();
                this.clickOrderNo = row.childList[0].orderNo;
                this.setCurrentRow('orderGridRef', row.childList[0]);
                this.handleSearch();
            }
        },
        getOrder () {
            queryTaskNo({ dispatchNo: this.dispatchNo })
                .then(res => {
                    if (res && +res.code === 0) {
                        this.orderOptions.data = res.data || [];
                        this.orderOptions.data.unshift(this.firstLineData);
                        this.setCurrentRow('orderGridRef', this.firstLineData);
                    }
                }).finally(() => {
                    if (this.taskNo) {
                        this.filterOrderTable();
                    } else {
                        this.getLog();
                    }
                });
        },
        getLog (data = {}) {
            this.loading = true;
            const param = {
                dispatchNo: this.dispatchNo,
                ...data
            };
            queryOperationLog(param).then(res => {
                if (res && +res.code === 0) {
                    this.logOptions.data = formatLogData(res.data || [], this.dictData);
                }
            }).finally(() => { this.loading = false; });
        },
        setCurrentRow (gridRef, row) {
            this.$nextTick(() => {
                this.$refs[gridRef].setCurrentRow(row);
            });
        },
        dblclickLogCell ({ row, column }) {
            if (column.field === 'remark' && row.remark) {
                copyToClip(row.remark);
            }
        },
        getDicData () {
            this.nodeOptions.data = formatDictDataToNodeId(this.dictData['TMS_OPERATION_NODE']);
            // 初始化选中第一行
            this.setCurrentRow('nodeGridRef', this.nodeOptions.data[0]);
        },
        handleClose () {
            this.$emit('update:isShowOperationNodeLog', false);
        },
        /**
         * 获取两个表格当前选中的数据
         * @returns {Object} 包含订单和节点选中数据的对象
         */
        getSelectedData () {
            const selectedOrder = this.$refs.orderGridRef && this.$refs.orderGridRef.getCurrentRecord();
            const selectedNode = this.$refs.nodeGridRef && this.$refs.nodeGridRef.getCurrentRecord();
            if (selectedOrder.id) {
                if (selectedOrder.childList) { // 选中客户单
                    return {
                        taskNo: '',
                        customerOrderNo: selectedOrder.orderNo,
                        operationNode: selectedNode.id === '00' ? '' : selectedNode.id
                    };
                } else { // 选中TK单
                    // const parentNode = this.orderOptions.data.find(v => v.childList && v.childList.some(i => i.id === selectedOrder.id));
                    return {
                        taskNo: selectedOrder.orderNo,
                        // customerOrderNo: parentNode ? parentNode.orderNo : '',
                        operationNode: selectedNode.id === '00' ? '' : selectedNode.id
                    };
                };
            } else { // 选中CP单
                return {
                    taskNo: '',
                    customerOrderNo: '',
                    operationNode: selectedNode.id === '00' ? '' : selectedNode.id
                };
            }
        }
    }
};